import React from 'react';

import { styled } from 'core/styles';

import { DateLabel } from '../DateLabel';

export function SynchronizationInfo({
  timestamp,
  hasOraclePrice,
  hasUnknownPrice,
}: {
  timestamp: Date;
  hasOraclePrice: boolean;
  hasUnknownPrice: boolean;
}) {
  return (
    <>
      Last updated <DateLabel date={timestamp} />.{' '}
      <Title>
        {hasOraclePrice &&
          'Some token prices may not be accurate as they are calculated using protocol oracle. '}
        {hasUnknownPrice &&
          'Some token prices may not be supported yet, and this may influence the total metric counts.'}
      </Title>
    </>
  );
}

const Title = styled('span')({
  opacity: 0.48,
});
